import { useQuery, keepPreviousData } from '@tanstack/react-query';

import { getProfessionalReviews } from '../services/professional-reviews.service';

const PAGE_SIZE = 10;

export function useProfessionalReviews(professionalId: string, page: number) {
  return useQuery({
    queryKey: ['professional-reviews', professionalId, page],
    queryFn: () => getProfessionalReviews(professionalId, page, PAGE_SIZE),
    enabled: !!professionalId,
    placeholderData: keepPreviousData,
  });
}
